<app-nav-pages></app-nav-pages>

  <section class="hero-section d-flex justify-content-center align-items-center csr-hero">
    <div class="overlay"></div>
    <div class="hero-text text-center  d-flex align-items-center flex-column gap-5 ">
      <h2>Reach Out Zumera 2023</h2>
    </div>
  </section>
  
  <section class="container context">
    <h2 class="text-center reach_out_header">The Unsung Heroes Of Resilience</h2>
    <p>The 2023 reach-out event shone a spotlight on the unsung heroes of our community: the widows, celebrating their resilience and strength. Through the intimate empowerment program, we forged memorable moments and  motivating connections, reaffirming our commitment to inspiring hope for those who often go unnoticed.
    </p>
  </section>

<section class="container ">
  <h1>Pictures from ReachOut Zumera 2023.</h1><hr>
  <div id="gallery" class="container-fluid">  
    <img src="assets/imgs/RO23_1.jpg" class="img-responsive" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal"type="button" data-bs-toggle="modal" data-bs-target="#exampleModal">
    <img src="assets/imgs/RO23_2.jpg" class="img-responsive" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal"type="button" data-bs-toggle="modal" data-bs-target="#exampleModal">
    <img src="assets/imgs/RO23_3.jpg" class="img-responsive" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal"type="button" data-bs-toggle="modal" data-bs-target="#exampleModal">
    <img src="assets/imgs/RO23_5.jpg" class="img-responsive" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal"type="button" data-bs-toggle="modal" data-bs-target="#exampleModal">
    <img src="assets/imgs/RO23_6.jpg" class="img-responsive" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal"type="button" data-bs-toggle="modal" data-bs-target="#exampleModal">
    <img src="assets/imgs/RO23_9.jpg" class="img-responsive" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal"type="button" data-bs-toggle="modal" data-bs-target="#exampleModal">
    <img src="assets/imgs/RO23_10.jpg" class=" img-responsive" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal"type="button" data-bs-toggle="modal" data-bs-target="#exampleModal">
    <img src="assets/imgs/RO23_11.jpg" class=" img-responsive" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal"type="button" data-bs-toggle="modal" data-bs-target="#exampleModal">

  </div>

  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          
        </div>
      </div>
    </div>

    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  </div>
  
</section>
<app-footer class="w-100 d-none d-sm-block"></app-footer>
<app-footer-sm  class="w-100 d-sm-none"></app-footer-sm>